<template>
  <div class="con_bg">
    <div>
      <header>
        <el-image :src="iconHeader"></el-image>
        <span class="title_font" @click="goBack()">{{ titleName }}</span>
      </header>
      <div class="title_line"></div>
      <body>
        <div v-show="isShowList">
          <ul>
            <li
              v-for="(item, ad) in testInfo.infoList"
              :key="ad"
              style="list-style: none"
            >
              <div class="news_bg t-h" @click="checkItem(item)">
                <el-image :src="item.src" class="video_bg_one">
                  <div slot="error">
                    <el-image :src="defaultImg"> </el-image></div
                ></el-image>
                <div>
                  <p>{{ item.examName }}</p>
                  <p></p>
                  <span> 考试简介：{{ item.examDesc }} </span>
                  <p></p>
                  <!-- <span>
                    考试时间：{{ item.startTime }}至{{ item.endTime }}
                  </span> -->
                </div>
              </div>
              <div class="line_two"></div>
            </li>
          </ul>
          <div style="text-align: center; margin-top: 8px">
            <el-pagination
              @current-change="handleCurrentChange"
              :page-size="pageParams.pageSize"
              layout="prev, pager, next"
              :total="testInfo.total"
            >
            </el-pagination>
          </div>
        </div>
        <div v-show="isShowContent">
          <div>
            <el-container>
              <el-main>
                <div style="margin-bottom: 20px">
                  <span style="margin-right:10px;">姓名：{{userName}}</span>
                  <span style="margin-right:10px;">开始时间：{{paperHeader.startTime}}</span>
                  <span style="margin-right:10px;">结束时间：{{paperHeader.endTime}}</span>
                  <span style="margin-right:10px;">考试时长：{{paperHeader.duration}}分钟</span>
                  <span style="margin-right:10px;">正确数量：{{successNum}}</span>
                  <span style="margin-right:10px;">总分数：{{totalScore}}</span>
                </div>
                <el-row>
                  <el-col :span="12">
                    <div>
                      <div
                        v-for="(item, index) in examList"
                        :key="index"
                        class="question_bg"
                      >
                        <div style="min-height:20px;margin:10px 0;">
                          <div style="float:left;">{{ index + 1 }}.</div>
                          <div style="float:left;display:flex;" class="ql-editor" v-html="item.quContentStr"></div>
                        </div>
                        <!-- <p>{{ index + 1 }}.{{ item.quContentStr }}</p> -->
                        <el-checkbox-group
                          v-if="item.quType == '2'"
                          v-model="item.dt"
                        >
                          <el-checkbox
                            v-for="(ad, index) in item.answers"
                            :label="ad.anOpindex"
                            :key="index"
                            >{{ ad.anOption }}</el-checkbox
                          >
                        </el-checkbox-group>
                        <el-radio-group
                          v-else-if="item.quType == '1'"
                          v-model="item.dt"
                        >
                          <el-radio
                            v-for="(ad, index) in item.answers"
                            :label="ad.anOpindex"
                            :key="index"
                            >{{ ad.anOption }}</el-radio
                          >
                        </el-radio-group>
                        <el-radio-group
                          v-if="item.quType == '3'"
                          v-model="item.dt"
                        >
                          <el-radio label="对">对</el-radio>
                          <el-radio label="错">错</el-radio>
                        </el-radio-group>
                        <el-input type="textarea" :rows="4" v-if="item.quType == '4'" v-model="item.dt"></el-input>
                      </div>
                    </div>
                    <br />
                  </el-col>
                </el-row>
              </el-main>
            </el-container>
            <div style="text-align: center" v-if="!isExaminationed">
              <el-button size="medium" @click="commitTest" type="success"
                >提交考卷</el-button
              >
            </div>
          </div>
        </div>
      </body>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import {
  getExamlist,
  getExamquestion,
  commitExamquestion,
  getPaperHead,
  examrecordInfo
} from "@/network/api";

export default {
  data() {
    return {
      defaultImg: require("@/assets/images/defalut_icon.png"),
      iconHeader: require("@/assets/images/pageico_7.png"),
      isShowContent: false,
      isShowList: true,
      htmlInfo: "",
      titleName: "考试中心",
      examList: [],
      arr: "",
      userId: "",
      examId: "",
      examName: "",
      examStartTime: "",
      examEndTime: "",
      nowDate: "",
      testInfo: {
        infoList: [],
        total: 0,
      },
      pageParams: {
        pageNum: 1,
        pageSize: 10,
      },
      paperHeader: {},
      userName: localStorage.getItem('userName'),
      isExaminationed: false,
      totalScore: 0,
      successNum: 0,
    };
  },
  mounted() {
    this.initData();
    let userToken = localStorage.getItem("userToken");
    if (userToken == null) {
      this.$alert("温馨提示", "请您先登录", {
        confirmButtonText: "确定",
      });
      return;
    }
  },
  methods: {
    checkItem(item) {
      let userToken = localStorage.getItem("userToken");
      if (userToken == null) {
        this.$alert("温馨提示", "请您先登录", {
          confirmButtonText: "确定",
        });
        return;
      }
      this.userId = userToken;
      let formData = new FormData();
      formData.append("examId", item.examId);
      getExamquestion(formData).then((res) => {
        if (res.code == 200) {
          this.examId = item.examId;
          this.examName = item.examName;
          this.formatDate();
          this.examStartTime = this.nowDate;
          res.data.forEach((el => {
            for (let item of el.questions) {
              !item.dt && (item.dt = []);
              let str = '';
              if (el.quType == 1) {
                str = "【单选题】";
              } else if (el.quType == 2) {
                str = "【多选题】";
              } else if (el.quType == 3) {
                str = "【判断题】";
              } else if (el.quType == 4) {
                str = "【简答题】";
                item.dt = '';
              }
              item.quContentStr = str + item.quContent;
              this.examList.push(item);
            }
          }))
          // for (let item of res.data[0].questions) {
          //   !item.dt && (item.dt = []);
          //   item.quContentStr = "【" + "单选题" + "】" + item.quContent;
          //   this.examList.push(item);
          // }
          // for (let item of res.data[1].questions) {
          //   !item.dt && (item.dt = []);
          //   item.quContentStr = "【" + "多选题" + "】" + item.quContent;
          //   this.examList.push(item);
          // }
          // for (let item of res.data[2].questions) {
          //   !item.dt && (item.dt = []);
          //   item.quContentStr = "【" + "判断题" + "】" + item.quContent;
          //   this.examList.push(item);
          // }
          this.isShowContent = true;
          this.isShowList = false;
          this.titleName = "考试中心 | " + item.examName + " |【返回】";
          examrecordInfo(item.examId).then(res => {
            if (res.data) {
              this.isExaminationed = true;
              const userAnswers = JSON.parse(res.data.userAnswers);
              this.successNum = userAnswers.length - Number(res.data.errorNum);
              this.totalScore = res.data.totalScore
              this.examList.forEach(el => {
                userAnswers.forEach(item => {
                  if (el.quId == item.quId) {
                    if (el.quType != 2) {
                      el.dt = item.answers
                    } else {
                      const arr = item.answers.split(',');
                      el.dt = arr
                    }
                  }
                })
              })
            }
          })
          getPaperHead(item.examId).then(res => {
            this.paperHeader = res.data;
          })
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    goBack() {
      this.isShowContent = false;
      this.isShowList = true;
      this.titleName = "考试中心";
      this.examList = [];
    },

    commitTest() {
      this.$confirm("您确定要提交答卷吗?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success",
      }).then(() => {
        this.submitCount();
      });
    },

    submitCount() {
      this.formatDate();
      this.examEndTime = this.nowDate;
      let timeLength = moment().diff(this.examStartTime, "minutes");

      console.log("提交试卷", this.examList);
      let answersInfo = [];
      for (let item of this.examList) {
        let answersStr = "";
        let itemAnswers = item.dt;
        if (itemAnswers instanceof Array) {
          itemAnswers.filter((arr, i) => {
            if (i == arr.length - 1) {
              answersStr += arr + ",";
            } else {
              answersStr += arr;
            }
          });
        } else {
          answersStr += itemAnswers;
        }
        let info = {
          quId: item.quId,
          quType: item.quType,
          answers: answersStr,
        };
        answersInfo.push(info);
      }
      console.log("----------- : ", answersInfo);
      let commitInfo = {
        // userId: this.userId,
        examId: this.examId,
        examName: this.examName,
        examStartTime: this.examStartTime,
        examEndTime: this.examEndTime,
        examDuration: timeLength,
        userAnswers: answersInfo,
      };
      // let formData = new FormData();
      // formData.append("userId", this.userId);
      // formData.append("examId", this.examId);
      // formData.append("examName", this.examName);
      // formData.append("examStartTime", this.examStartTime);
      // formData.append("examEndTime", this.examEndTime);
      // formData.append("examDuration", 12);
      // formData.append("userAnswers", answersInfo);
      // commitExamquestion(commitInfo).then((res) => {});
      // let url = "http://47.97.209.208:7111/api/exam/handover";
      //let url = "http://39.107.40.85/prod-api/exam/handover";
      // let criteria = JSON.stringify({ id: this.form.region });
      commitExamquestion(commitInfo).then(res => {
        if (res.code == 200) {
          this.$alert(
            "您本次考试总分数为" + res.data.totalScore + "（简答题除外）",
            "您已成功提交答卷",
            {
              confirmButtonText: "确定",
              showClose: false,
              callback: (action) => {
                this.goBack();
              },
            }
          );
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    //获取时间的方法
    formatDate() {
      let date = new Date();
      let year = date.getFullYear(); // 年
      let month = date.getMonth() + 1; // 月
      let day = date.getDate(); // 日
      let week = date.getDay(); // 星期
      // let weekArr = [
      //   "星期日",
      //   "星期一",
      //   "星期二",
      //   "星期三",
      //   "星期四",
      //   "星期五",
      //   "星期六",
      // ];
      let hour = date.getHours(); // 时
      hour = hour < 10 ? "0" + hour : hour; // 如果只有一位，则前面补零
      let minute = date.getMinutes(); // 分
      minute = minute < 10 ? "0" + minute : minute; // 如果只有一位，则前面补零
      let second = date.getSeconds(); // 秒
      second = second < 10 ? "0" + second : second; // 如果只有一位，则前面补零
      //this.nowDate = `${year}/${month}/${day} ${hour}:${minute}:${second} ${weekArr[week]}`;
      this.nowDate = `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },

    initData: function () {
      getExamlist(this.pageParams).then((res) => {
        this.testInfo.infoList = res.rows;
        this.testInfo.total = res.total;
      });
    },
    handleCurrentChange(val) {
      this.pageParams.pageNum = val;
      this.initData();
    },
  },
};
</script>


<style scoped>
ul,
li {
  margin: 0;
  padding: 0;
}
.con_bg {
  display: flex;
  justify-content: center;
}
header {
  width: 1150px;
  display: flex;
  margin-bottom: 6px;
  align-items: center;
}
body {
  width: 1150px;
  margin-top: 12px;
  margin-bottom: 12px;
}
.news_bg {
  display: flex;
  margin-top: 12px;
}
.news_bg p {
  font-size: 18px;
  font-weight: bold;
  padding-bottom: 5px;
  margin-left: 12px;
}
.news_bg span {
  font-size: 16px;
  color: #909090;
  margin-left: 12px;
}
.title_line {
  padding: 0;
  height: 1px;
  background-color: #b7b7b7;
}
.title_font {
  color: #397b3e;
  font-size: 20px;
  margin-left: 6px;
  cursor: pointer;
}
.line_two {
  border-bottom: 1px dashed #e2e2e2;
  margin-top: 12px;
}

ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}

.question_bg {
  margin-bottom: 12px;
}
.video_bg_one {
  width: 264px;
  height: 174px;
}
.t-h:hover {
  color: #397b3e;
  cursor: pointer;
}
.t-h:hover p {
  color: #397b3e;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/TestCenter.vue